import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import { useEffect, useState } from "react";
import { PiArrowDownBold } from "react-icons/pi";
import GlobalDiscount from "./sub-components/GlobalDiscount";
import AffiliateLevelDiscount from "./sub-components/AffiliateLevelDiscount";
import UserSpesialDiscount from "./sub-components/UserSpesialDiscount";
import ExtraDiscount from "./sub-components/ExtraDiscount";
import { getApi } from "../../services/api/globalApi";

export default function Discount() {
  const [accardionToggle, setAccardionToggle] = useState({
    subMenu1: false,
    subMenu2: false,
    subMenu3: false,
    subMenu4: false,
  });

  const [data,setData]=useState({})

  const getDiscountData = async () => {
    const path = 'admin/discounts/discount'
    try {
      const data = await getApi({path})
     setData(data?.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    getDiscountData()
  },[])

  return (
    <AdminFormLayout title={"مدیریت تخفیف"} description="بخش مورد نظر را باز کنید و شرایط تخفیف را همان‌جا ذخیره کنید.">

      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu1: !accardionToggle.subMenu1,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تخفیف عمومی</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu1 && "hidden"}`}>
            <GlobalDiscount data={data?.globalDiscount} />
          </div>
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu2: !accardionToggle.subMenu2,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تخفیفات نماینده</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu2 && "hidden"}`}>
            <AffiliateLevelDiscount data={data?.affiliateLevelDiscount} />
          </div>
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu3: !accardionToggle.subMenu3,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تخفیف یوزر خاص</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu3 && "hidden"}`}>
            <UserSpesialDiscount data={data?.userSpesialDiscount} />
          </div>
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu4: !accardionToggle.subMenu4,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تخفیف اضافه</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu4 && "hidden"}`}>
            <ExtraDiscount data={data?.extraDiscount} />
          </div>
        </div>
      </div>
    </AdminFormLayout>
  );
}
